<template>
  <div
    ref="infoContainer"
    class="inct-info-element"
  >
    <button
      class="inct-info-element-anchor"
      aria-haspopup="true"
      tabindex="0"
      @focus="calculatePosition"
    >
      <font-awesome-icon icon="info-circle"/>
    </button>
    <div
      ref="info"
      class="inct-info-element-tooltip"
      :class="[('inct-tooltip-'+calcPosition), 'inct-tooltip-shift-' + shiftTooltip]"
    >
      <slot/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InctInfoElement',
  data() {
    return {
      active: false,
      shiftTooltip: 'none',
      calcPosition: 'right'
    }
  },
  mounted() {
    this.active = true
  },
  methods: {
    calculatePosition() {
      this.shiftTooltip = "none";
      const tooltipContainerPositionX = this.$refs.infoContainer.getBoundingClientRect().x;
      const tooltipContainerPositionY = this.$refs.infoContainer.getBoundingClientRect().y;
      //calculating spaces left on each side when tooltip is open
      const spaces = {
        right: window.visualViewport.width - tooltipContainerPositionX - this.$refs.infoContainer.offsetWidth - this.$refs.info.offsetWidth,
        left: tooltipContainerPositionX - this.$refs.info.offsetWidth,
        bottom: window.visualViewport.height - tooltipContainerPositionY - this.$refs.infoContainer.offsetHeight - this.$refs.info.offsetHeight,
        top: tooltipContainerPositionY - this.$refs.info.offsetHeight
      };
      //if wanted space is too little for tooltip, choose the largest space
      if (spaces[this.calcPosition] < 0) {
        const orderedSpaces = Object.entries(spaces).sort((prev, next) => next[1] - prev[1])
        this.calcPosition = orderedSpaces[0][0];
      }
      //for shifting the tooltip in one direction to prevent it to go over viewport
      let i = 0;
      for (const dir of ['left', 'right', 'top', 'bottom']) {
        if (this.calcPosition === "top" || this.calcPosition === "bottom") {
          if (this.calcPosition !== Object.keys(spaces)[i] &&
            spaces[dir] + this.$refs.info.offsetWidth + (this.$refs.infoContainer.offsetWidth / 2) < (this.$refs.info.offsetWidth / 2)) {
            this.shiftTooltip = Object.keys(spaces)[i];
          }
        } else {
          if (this.calcPosition !== Object.keys(spaces)[i] &&
            spaces[dir] + this.$refs.info.offsetHeight + (this.$refs.infoContainer.offsetHeight / 2) < (this.$refs.info.offsetHeight / 2)) {
            this.shiftTooltip = Object.keys(spaces)[i];
          }
        }
        i++;
      }

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.inct-info-element {
  display: flex;
  position: relative;
  width: fit-content;

  &:focus-within .inct-info-element-tooltip {
    opacity: 1;
    visibility: visible;
  }

  .inct-info-element-anchor {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: 18px;
    color: #004e9f;
  }

  .inct-info-element-tooltip {
    padding: 10px;
    width: 400px;
    position: absolute;
    z-index: 100;
    border: 1px solid #4a4a4a;
    background: #f0f0f0;
    box-shadow: 1px 1px 3px #aaa;
    opacity: 0;
    visibility: hidden;
    transition: 300ms;

    @media screen and (max-width: 500px) {
      width: 80vw;
    }

    &.inct-tooltip-left {
      right: 100%;
      margin: 0 5px 0 0;
      top: 50%;
      -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }

    &.inct-tooltip-right {
      left: 100%;
      margin: 0 0 0 5px;
      top: 50%;
      -webkit-transform: translateY(-50%);
      -ms-transform: translateY(-50%);
      transform: translateY(-50%);
    }

    &.inct-tooltip-top {
      bottom: 100%;
      margin: 0 0 5px 0;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translate(-50%);
    }

    &.inct-tooltip-bottom {
      top: 100%;
      margin: 5px 0 0 0;
      left: 50%;
      -webkit-transform: translateX(-50%);
      -ms-transform: translateX(-50%);
      transform: translate(-50%);
    }

    &.inct-tooltip-shift-left {
      transform: translate(0);
      right: 0;
      left: unset;
    }

    &.inct-tooltip-shift-right {
      transform: translate(0);
      left: 0;
    }

    &.inct-tooltip-shift-top {
      transform: translateY(0);
      top: 100%;
    }

    &.inct-tooltip-shift-bottom {
      transform: translateY(0);
      top: 0;
    }

    > .subtitle {
      @media screen and (max-width: 600px) {
        font-size: 14px;
      }
    }

  }
}
</style>
